/*
 * @Author: Dong
 * @Date: 2022-05-06 13:26:20
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-25 16:12:15
 */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Switch, Form, Input, Tooltip, message, Spin, Checkbox } from 'sup-ui';
import copy from 'copy-to-clipboard';
import Modal from 'root/components/CommonModal';
import Icon from 'root/components/Icon';
import { WrappedFormUtils } from 'sup-ui/lib/form/Form';
import messages from '../messages';
import styles from './index.less';
import { operationTimeSequence, getTimeSequence } from 'root/services/syncBack';
import { formatDate } from 'root/utils/utils';
import { syncBack } from 'root/store/actions';
import { useDispatch } from 'react-redux';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';

interface PropsType {
  form: WrappedFormUtils;
}

const { confirm } = Modal;

const formItemLayout = {
  labelCol: {
    sm: { span: 4 },
  },
  wrapperCol: {
    sm: { span: 20 },
  },
};

let timer: any;

const SequenceSync = (props: PropsType) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { getFieldDecorator, validateFields } = props.form;

  const [visible, setVisible] = useState<boolean>(false);
  const [dataInfo, setDataInfo] = useState<any>({});
  const [spinning, setSpinning] = useState<any>(false);
  const [confirmPath, setConfirmPath] = useState(false);

  useEffect(() => {
    getData();
    return () => {
      // 组件将要卸载 清除定时器
      clearTimeout(timer);
      timer = null;
    };
  }, []);

  useEffect(() => {
    if (!visible) setConfirmPath(false);
  }, [visible]);

  const getData = () => {
    getTimeSequence().then((res) => {
      setDataInfo(res.data);

      // 如果正在开始备份 需要轮循获取最新信息
      const { action } = res.data;
      if (action === 'start') {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          getData();
        }, 16 * 1000);
      }
    });
  };

  // 开关同步备份
  const handleChangeOpen = (checked: boolean) => {
    // 打开同步备份时，显示配置弹框
    if (checked) {
      return toggleVisible();
    }

    // 关闭同步备份时，二次确认
    confirm({
      title: intl.formatMessage(messages.confirmCloseSequenceCheckedTip),
      onOk: () => {
        const params = {
          action: 'stop',
        };
        operationTimeSequence(params).then(() => {
          getData();
          dispatch(syncBack.getLogRecord());
        });
      },
    });
  };

  const toggleVisible = () => {
    setVisible(!visible);
  };

  // 保存配置信息
  const handleOk = () => {
    validateFields((err, values) => {
      if (err) return;
      let { pwd } = values;
      pwd = Base64.stringify(Utf8.parse(pwd));
      const params = { ...values, pwd };
      setSpinning(true);
      operationTimeSequence(params)
        .then(() => {
          toggleVisible();
          getData();
          dispatch(syncBack.getLogRecord());
        })
        .finally(() => {
          setSpinning(false);
        });
    });
  };

  // 复制路径
  const copyPath = () => {
    if (!dataInfo?.message?.rsyncPath) return;

    copy(dataInfo?.message?.rsyncPath);
    message.success(intl.formatMessage(messages.successCopy));
  };
  const changeConfirm = (e: any) => {
    const val = e.target.checked;
    setConfirmPath(val);
  };

  const renderTooltip = () => {
    return (
      <div className={styles.tooltipBox}>
        <p>{intl.formatMessage(messages.backupFilePath)}</p>
        <div className={styles.tooltipBox}>
          <div className={styles.tooltipLabel}>
            <span>IP</span>
            <span>{intl.formatMessage(messages.port)}</span>
          </div>
          <div className={styles.tooltipValue}>
            <span>{dataInfo?.message?.ip}</span>
            <span>{dataInfo?.message?.port}</span>
          </div>
        </div>
        <div className={styles.tooltipBox}>
          <div className={styles.tooltipLabel}>
            <span>{intl.formatMessage(messages.filePath)}</span>
          </div>
          <div className={styles.tooltipValue}>
            <span>{dataInfo?.message?.rsyncPath}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {intl.formatMessage(messages.sequenceDataSync)}
        <Tooltip title={intl.formatMessage(messages.sequentialIntroduce)} overlayClassName={styles.TooltipBox}>
          <div>
            <Icon type="tip16" className={styles.titleTipIcon} />
          </div>
        </Tooltip>
      </h2>

      <div className={styles.content}>
        <div className={styles.switchBox}>
          <span>{intl.formatMessage(messages.sequenceSyncBackup)}</span>
          <Switch size="small" checked={dataInfo?.action === 'start'} onChange={handleChangeOpen} />
        </div>
        <ul className={styles.detailBox}>
          <li>
            <span>
              {intl.formatMessage(messages.lastSyncTime)} : {formatDate(Number(dataInfo?.stop)) || '----'}
            </span>

            <Tooltip title={renderTooltip} overlayClassName={styles.TooltipBox}>
              <div onClick={copyPath}>
                <Icon type="tip16" className={styles.tipIcon} />
              </div>
            </Tooltip>
          </li>
          <li>
            {intl.formatMessage(messages.startTime)} : {formatDate(Number(dataInfo?.start)) || '----'}
          </li>
        </ul>
      </div>
      <Modal
        destroyOnClose
        visible={visible}
        title={intl.formatMessage(messages.sequenceModalTitle)}
        onOk={handleOk}
        onCancel={toggleVisible}
        height="auto"
        okButtonProps={{ disabled: spinning || !confirmPath }}
      >
        <Spin spinning={spinning}>
          <Form {...formItemLayout}>
            <Form.Item label="IP">
              {getFieldDecorator('ip', {
                initialValue: dataInfo?.message?.ip,
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.ipRequired),
                  },
                  {
                    pattern: new RegExp(
                      /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/,
                    ),
                    message: intl.formatMessage(messages.ipError),
                  },
                ],
              })(<Input maxLength="64" />)}
            </Form.Item>
            <Form.Item label={intl.formatMessage(messages.port)}>
              {getFieldDecorator('port', {
                initialValue: dataInfo?.message?.port,
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.portRequired),
                  },
                  {
                    message: intl.formatMessage(messages.portError),
                    pattern: new RegExp(
                      /^([1-9](\d{0,3}))$|^([1-5]\d{4})$|^(6[0-4]\d{3})$|^(65[0-4]\d{2})$|^(655[0-2]\d)$|^(6553[0-5])$/,
                    ),
                  },
                ],
              })(<Input maxLength="64" />)}
            </Form.Item>
            <Form.Item label={intl.formatMessage(messages.userName)}>
              {getFieldDecorator('user', {
                initialValue: dataInfo?.message?.user,
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.userNameRequired),
                  },
                ],
              })(<Input autoComplete="off" maxLength="64" />)}
            </Form.Item>
            <Form.Item label={intl.formatMessage(messages.password)}>
              {getFieldDecorator('pwd', {
                initialValue: dataInfo?.message?.pwd,
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.passwordRequired),
                  },
                ],
              })(<Input.Password autoComplete="new-password" maxLength="64" />)}
            </Form.Item>
            <Form.Item label={intl.formatMessage(messages.savePath)}>
              {getFieldDecorator('rsyncPath', {
                initialValue: dataInfo?.message?.rsyncPath,
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.savePathRequired),
                  },
                ],
              })(<Input maxLength="64" />)}
            </Form.Item>
          </Form>
          <Checkbox onChange={changeConfirm}>
            <span>{intl.formatMessage(messages.rsyncConfirm)}</span>
          </Checkbox>
        </Spin>
      </Modal>
    </div>
  );
};

export default Form.create()(SequenceSync);
